"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscribe = Subscribe;
exports.Publish = Publish;
const events_1 = require("events");
// 创建全局事件发射器实例
const emitter = new events_1.EventEmitter();
/**
 * 订阅指定通道的事件
 * @template T 消息数据类型
 * @param channel 通道/事件名称
 * @param fn 收到消息时的回调函数
 */
function Subscribe(channel, fn) {
    emitter.on(channel, (message) => {
        fn(message);
    });
}
/**
 * 向指定通道发布事件消息
 * @template T 消息数据类型
 * @param channel 通道/事件名称
 * @param message 要发送的消息内容
 */
function Publish(channel, message) {
    emitter.emit(channel, message);
}
exports.default = {
    Subscribe,
    Publish,
};
